module.exports = __webpack_public_path__ + "static/media/mastercard.db4c8702.png";